<template lang="pug">
  v-main#register
    v-container(
      id="register"
      fill-height
    )
      v-row.login-row(
        align="center"
      ) 
        img(
          @click="$router.push('/')"
          class="p-4"
          src="@/assets/logo.png"
        )
        v-form.login-form(ref="form")
          h1 Welcome
          v-text-field(
            outlined
            prepend-inner-icon="mdi-account"
            v-model="customerId" 
            :rules="idRules"
            required
            label="Username"
            hint="At least 5 characters"
            :counter="20"
          )
          v-text-field(
            outlined
            prepend-inner-icon="mdi-comment-account"
            v-model="customerName" 
            :rules="nameRules"
            required
            label="Full Name"
          )
          v-text-field(
            outlined
            prepend-inner-icon="mdi-cake"
            v-model="customerDob" 
            label="Date of Birth"
            hint="*Optional* Fill to get extra rewards"
            type="date"
          )
          v-text-field(
            outlined
            prepend-inner-icon="mdi-email"
            v-model="customerEmail" 
            :rules="emailRules"
            required
            label="E-Mail"
          )
          v-text-field(
            outlined
            prepend-inner-icon="mdi-cellphone"
            v-model="customerPhone" 
            :rules="phoneRules"
            required
            label="Phone Number"
            type="number"
          )
          v-text-field(
            outlined
            prepend-inner-icon="mdi-lock"
            v-model="customerPassword" 
            :rules="passwordRules"
            label="Password"
            required
            type="password"
            hint="At least 8 characters"
            :counter="20"
          )
          v-text-field(
            outlined
            prepend-inner-icon="mdi-repeat-once"
            v-model="customerRepeat" 
            :rules="repeatRules"
            label="Confirm Password"
            required
            type="password"
            :counter="20"
          )
          v-btn(
            class="my-2"
            color="success"
            @click="register"
          ) Register &nbsp;
          v-btn(
            class="my-2"
            text
            color="primary"
            block 
            depressed
            @click="goto"
          ) Back to login page.
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  name: "Login",
  data() {
    return {
      customerId: "",
      customerName: "",
      customerEmail: "",
      customerPhone: "",
      customerPassword: "",
      customerRepeat: "",
      customerDob: "",
      nameRules: [v => !!v || "Name is required"],
      idRules: [
        v => !!v || "Username is required",
        v => /^[a-z\d.]*$/i.test(v) || "Username must be alphanumeric only."
      ],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      passwordRules: [
        v => !!v || "Password is required",
        v => (v && v.length >= 8) || "Password must be at least 8 characters"
      ],
      phoneRules: [
        v => !!v || "Phone Number is required",
        v => !/^\d+$/.test(v) || "Phone number must be valid"
      ],
      repeatRules: [
        v => !!v || "Password is required",
        v => (v && v == this.customerPassword) || "Password must be identical"
      ],
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  mounted() {
    $(".v-footer").css("margin-bottom", "0px");
    $(document).off("keypress");
    $(document).keypress(event => {
      var keycode = event.keyCode ? event.keyCode : event.which;
      if (keycode == "13") this.register();
    });
  },
  methods: {
    goto() {
      this.$router.push("/login");
    },
    register() {
      if (!this.$refs.form.validate()) return;

      let url = config.registerUrl();

      var json = {
        customer_id: this.customerId,
        customer_name: this.customerName,
        customer_email: this.customerEmail,
        customer_phoneno: this.customerPhone,
        customer_signupmethod: "default",
        customer_dob: this.customerDob,
        customer_lang: "en",
        customer_password: md5(this.customerPassword)
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (!this.feedback.success) {
                this.$swal(
                  this.$t("error.login"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(this.$t("error.login"), response.body.message, "error");
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(this.$t("error.login"), response.body.message, "error");
        });
    }
  }
};
</script>
